import { render } from "./template.1366.vue?vue&type=template&id=88d7ea36"
import script from "./template.1366.vue?vue&type=script&lang=js"
export * from "./template.1366.vue?vue&type=script&lang=js"

import "./template.1366.vue?vue&type=style&index=0&id=88d7ea36&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__